import React from "react";
import "./cart.css";
import CartItems from "../CartItems/cartitems";

const Cart = () => {
  return (
    <div className="cart">
      <CartItems />
    </div>
  );
};

export default Cart;
